import React from "react"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Alert } from "reactstrap"

interface ConfirmErrorMessageProps {
  errorCode?: string
}

const ConfirmErrorMessage: React.FC<ConfirmErrorMessageProps> = ({errorCode}) => {
  const { t } = useTranslation();
  if (!errorCode) return <Fragment></Fragment>;

  if (errorCode === 'PAYPAL2_PAYER_ACTION_REQUIRED' || errorCode === 'PAYPAL2_CART_ORDER_DIVERSION') {
    return (
      <Alert color="warning" className="w-100">
        <p>
          {t(`CHECKOUT.${errorCode}`)} <Link to="checkout/payment">{t(`CHECKOUT.${errorCode}_LINK`)}</Link>
        </p>
      </Alert>
    )
  }
  if (errorCode === 'FAILURE') {
    return (
      <Alert color="warning" className="w-100">
        <p>
          {t(`CHECKOUT.CONFIRM_FAILURE`)}
        </p>
      </Alert>
    )
  } else {
    return (
      <Alert color="warning" className="w-100">
        <p>
          {t(`CHECKOUT.CONFIRM_UNKNOWN_FAILURE`)}
        </p>
      </Alert>
    )
  }
}

export default ConfirmErrorMessage
